// extracted by mini-css-extract-plugin
export default {"toolbox":"learningZoneToolbox_toolbox__NKubE","btnsContainer":"learningZoneToolbox_btnsContainer__Kzcrp","widgetIcon":"learningZoneToolbox_widgetIcon__GArP7"};